import React, { useEffect, useState } from 'react';
import arrow_enter from '../../../images/speaker-big.png'
import Button from '../Button';

import './SoundButton.css';

const SoundButton = (props) => {
    let cl = props.className ? props.className : ""
    cl += "sound-button"
    return <Button {...props} pill className={cl} > 
        <div className="sound" >
            <img src={arrow_enter} />
        </div>
    </Button>};

export default SoundButton;